<template>
  <section>
    <div
      class="content-box content-box__color-secondary content-box__inner-wrapper content-box__has-image text-center"
    >
      <div class="content-box__title">
        <h2>{{ $t('confirm.title') }}</h2>
      </div>

      <div class="content-box__content">
        <v-row>
          <v-col cols="10" offset="1" md="8" offset-md="2">
            <template v-if="loading">
              <p>{{ $t('confirm.inProgress') }}</p>
              <v-progress-linear indeterminate height="10"></v-progress-linear>
            </template>

            <template v-else-if="success">
              <v-alert type="success" text>
                {{ $t('confirm.success') }}
              </v-alert>

              <v-btn color="primary" class="mt-2" @click="goToLogin">
                {{ $t('confirm.signIn') }}
              </v-btn>
            </template>

            <template v-else>
              <v-alert type="error" text>
                {{ $t(`confirm.errors.${errorKey}`) }}
              </v-alert>
            </template>
          </v-col>
        </v-row>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getStoredApplicationDraftJobofferId } from '@/helpers/ApplicationDraftStorage.js';

export default {
  name: 'AccountConfirmView',

  data: () => ({
    loading: true,
    success: false,
    errorKey: 'failed',
    returnJobofferId: null
  }),

  computed: {
    ...mapState('companyModule', {
      slug: 'slug'
    })
  },

  async mounted() {
    const token = this.$route.params.token;

    const result = await this.confirmAccount(token);

    this.success = !!(result && result.success);
    if (!this.success) {
      this.errorKey = (result && result.error) || 'failed';
    } else {
      // If the candidate left an application mid-way to register, resume it after
      // login; otherwise land them on the cockpit.
      this.returnJobofferId = getStoredApplicationDraftJobofferId();
    }

    this.loading = false;
  },

  methods: {
    ...mapActions('candidateModule', ['confirmAccount', 'login']),

    goToLogin() {
      // Sign in via Keycloak, then return to the resumed application (if any) or
      // the cockpit. History-mode routes are absolute URLs with no fragment, which
      // is exactly what Keycloak needs as a redirect target.
      const path = this.returnJobofferId
        ? `/${this.slug}/apply/${this.returnJobofferId}`
        : `/${this.slug}/cockpit`;

      this.login(`${window.location.origin}${path}`);
    }
  }
};
</script>
